import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import CalendarIcon from '../../../public/website_next_images/masterclass/calendar.png';
import TimerIcon from '../../../public/website_next_images/masterclass/timer.png';
// import required modules
import { Autoplay } from 'swiper';
import Image from 'next/image';
const swiperOptions = {
  spaceBetween: 0,
  speed: 6000,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
  },
  loop: true,
  grabCursor: false,
  slidesPerView: 'auto' as 'auto',
  shortSwipes: false,
  longSwipes: false,
  allowTouchMove: false,
  modules: [Autoplay],
};
const BannerRibbon = ({ data }: { data: any }) => {
  const ribbonList = data.keyPoints;
  return (
    <>
      {ribbonList.length > 0 && (
        <section className="bg-[#1F1F1F]  md:py-[19px] py-[14px] ">
          <div className="hidden md:block">
            {ribbonList.length <= 3 && (
              <div className="md:mx-auto max-w-[1440px]">
                <div className="bootcamp-info-wrap md:block hidden text-white">
                  <div className="flex items-center justify-center">
                    {ribbonList.map((ele, index) => {
                      return (
                        <div className=" md:!w-auto flex items-center justify-center" key={index}>
                          <div className="data-wrap flex items-center justify-center mr-6 ">
                            <div className="circle-wrap flex justify-center items-center mr-6">
                              <div className="red-circle bg-spriteImg w-6 h-6" />
                            </div>
                            {ele.icon && (
                              <div className={`flex justify-center items-center mr-3`}>
                                {ele.icon == 'calendar' && (
                                  <i className="calendar-icon inline-block bg-spriteImg md:w-5 md:h-[22px] w-[14px] h-4" />
                                )}
                                {ele.icon == 'timer' && (
                                  <i className="timer-icon inline-block bg-spriteImg md:w-[22px] md:h-[22px] w-4 h-4" />
                                )}
                              </div>
                            )}
                            <p className="text-base leading-5 md:text-lg font-regular md:leading-[21px] text-center ">
                              {ele.label}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
            {ribbonList.length > 3 && (
              <div className="md:mx-auto max-w-[1440px]">
                <div className="bootcamp-info-wrap md:block  text-white">
                  <div className="flex ">
                    <Swiper {...swiperOptions}>
                      {ribbonList.map((ele, index) => {
                        return (
                          <SwiperSlide className=" md:!w-auto md:!h-6 " key={index}>
                            <div className="data-wrap flex items-center mr-6 ">
                              <div className="circle-wrap flex items-center mr-6">
                                <div className="red-circle bg-spriteImg w-6 h-6" />
                              </div>
                              {ele.icon && (
                                <div className={`flex items-center mr-3`}>
                                  {ele.icon == 'calendar' && (
                                    <i className="calendar-icon inline-block bg-spriteImg md:w-5 md:h-[22px] w-[14px] h-4" />
                                  )}
                                  {ele.icon == 'timer' && (
                                    <i className="timer-icon inline-block bg-spriteImg md:w-[22px] md:h-[22px] w-4 h-4" />
                                  )}
                                </div>
                              )}
                              <p className="text-base leading-5 md:text-lg font-regular md:leading-[21px] text-center ">
                                {ele.label}
                              </p>
                            </div>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="block md:hidden">
            <div className="md:mx-auto max-w-full">
              <div className="bootcamp-info-wrap md:block  text-white">
                <div className="flex items-center justify-center">
                  <Swiper {...swiperOptions}>
                    {ribbonList.map((ele, index) => {
                      return (
                        <SwiperSlide className=" md:!w-auto flex items-center justify-center" key={index}>
                          <div className="data-wrap flex items-center justify-center ">
                            <div className="circle-wrap flex justify-center items-center pr-[18px]">
                              <div className="red-circle bg-spriteImg md:w-6 md:h-6 w-5 h-5" />
                            </div>
                            {ele.icon && (
                              <div className={`flex justify-center items-center `}>
                                {ele.icon == 'calendar' && (
                                  <i className="calendar-icon inline-block bg-spriteImg md:w-5 md:h-[22px] w-[14px] h-4 mr-3" />
                                )}
                                {ele.icon == 'timer' && (
                                  <i className="timer-icon inline-block bg-spriteImg md:w-[22px] md:h-[22px] w-4 h-4 mr-3" />
                                )}
                              </div>
                            )}
                            <p className=" text-base leading-5 md:text-lg font-regular md:leading-[21px] text-center ">
                              {ele.label}
                            </p>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
export default BannerRibbon;
